import { render, staticRenderFns } from "./CurrencyTableRow.vue?vue&type=template&id=57210d5e&scoped=true&"
import script from "./CurrencyTableRow.vue?vue&type=script&lang=js&"
export * from "./CurrencyTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57210d5e",
  null
  
)

export default component.exports